/* ---- 18 Aug 2026: exclusive accordions ----
   Theme's native accordion component (snippets/accordion.liquid, used by the FAQ
   section and every ingredient/verification accordion on Formula) has no built-in
   "close the others when one opens" behaviour. Flagged by Marianna's brother:
   opening a new question/panel leaves every previously-opened one still open.
   Fix is JS, not a markup change, because the accordion markup is generated by a
   shared theme snippet used across many sections — this listens for the native
   <details> "toggle" event and, scoped to the nearest .shopify-section, closes any
   sibling accordion that was left open. Section-scoped so unrelated accordions
   elsewhere on the same page (e.g. Formula's ingredient list vs its verification
   list, which sit in separate sections) are not accidentally linked together. */
(function () {
  document.addEventListener(
    'toggle',
    function (event) {
      var details = event.target;
      if (!details || details.tagName !== 'DETAILS' || !details.open) return;
      if (!details.closest('accordion-disclosure')) return;

      var section = details.closest('.shopify-section');
      if (!section) return;

      var openSiblings = section.querySelectorAll('accordion-disclosure > details[open]');
      openSiblings.forEach(function (sibling) {
        if (sibling !== details) {
          sibling.open = false;
          sibling.setAttribute('aria-expanded', 'false');
        }
      });
    },
    true
  );
})();


/* ---- 8 Sep 2026: "Join the list" buttons on the product page (Begin/Build) ----
   Marianna reported these buttons just land at the top of the homepage instead of
   jumping to the Spark List signup. Root cause: the button's href was hardcoded to
   /#shopify-section-spark_list, but Shopify's actual generated wrapper id for a
   JSON-template section is `shopify-section-template--<unique-id>__<section_key>`
   (confirmed live: shopify-section-template--30911319441748__spark_list) — the
   plain `shopify-section-spark_list` guess never matches anything in the page, so
   the browser just loads the homepage and stays at the top. That numeric template
   id isn't something we set and can change if the template is ever recreated (for
   instance, a future theme duplicate can regenerate it), so hardcoding today's id
   into the button would only break again later for the same reason.
   Fixed with a stable sentinel hash instead — the buttons now point to
   /#join-the-list — resolved here at runtime against the real newsletter section
   via the [id$="__spark_list"] suffix-match pattern already used elsewhere in this
   project for the same "don't depend on Shopify's generated id prefix" reason
   (see custom-overrides.css, e.g. [id$="__contact-form"], [id$="__shop_value"]).
   Handles both a fresh navigation from the product page to the homepage anchor,
   and a same-page click were this hash ever used on the homepage itself.
   Uses an instant jump (not 'smooth'), fired twice — once early and once after
   images below the fold have had time to load — rather than a single smooth
   animation: tested live, a single smooth scroll over this distance (the
   section sits ~9,500px down the homepage) was unreliable, landing well short
   some runs. A layout shift from a still-loading image partway through the
   animation is the likely cause. Two instant jumps sidestep that: the second
   one corrects for any shift the first one couldn't have known about yet. */
(function () {
  function scrollToSparkList() {
    var target = document.querySelector('[id$="__spark_list"]');
    if (target) {
      target.scrollIntoView({ behavior: 'auto', block: 'start' });
    }
  }

  if (window.location.hash === '#join-the-list') {
    /* This script can execute after the page's own 'load' event has already
       fired (observed live: readyState was already 'complete' by the time this
       ran), so a plain addEventListener('load', ...) can silently miss it and
       never scroll. Check readyState first and act immediately if we're already
       past load; only wait for the event if we genuinely haven't hit it yet. */
    if (document.readyState === 'complete') {
      setTimeout(scrollToSparkList, 50);
      setTimeout(scrollToSparkList, 800);
    } else {
      window.addEventListener('load', function () {
        setTimeout(scrollToSparkList, 50);
        setTimeout(scrollToSparkList, 800);
      });
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href$="#join-the-list"]');
    if (!link) return;
    if (link.pathname === window.location.pathname) {
      event.preventDefault();
      scrollToSparkList();
      history.replaceState(null, '', '#join-the-list');
    }
  });
})();


/* ---- 17 Sep 2026: cookie-policy banner doesn't remember being dismissed ----
   Marianna reported the branded cookie-policy banner (sections/privacy-banner.liquid,
   the theme's own stock component, not something built for GQL) reappears on every
   page navigation even after clicking Accept or Decline. Confirmed live before writing
   this: clicking Accept writes no new cookie and no new localStorage key at all — the
   vendor component's own "remember this visitor dismissed me" step isn't landing. This
   is separate from real GDPR consent tracking, which is unaffected and already working
   (window.Shopify.customerPrivacy reports full consent granted independently of this
   banner) — this fixes only the notice banner's own re-show behaviour.
   Deliberately not patched inside theme.js (a large, generated, vendor-owned bundle —
   not something to hand-edit blind). Instead, additive and self-contained: on Accept or
   Decline, record a local flag; on every later load where that flag is present, force
   the banner hidden via the [hidden] attribute (theme.css already treats [hidden] as
   display:none !important, confirmed in the base reset). A MutationObserver re-applies
   the hidden attribute if the vendor component's own init tries to remove it after our
   first pass runs, so this holds regardless of the component's internal load timing. */
(function () {
  var KEY = 'gql_privacy_banner_dismissed';

  function isDismissed() {
    try {
      return localStorage.getItem(KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function enforceHidden(banner) {
    if (banner && !banner.hasAttribute('hidden')) {
      banner.setAttribute('hidden', '');
    }
  }

  if (isDismissed()) {
    var applyHidden = function () {
      var banner = document.querySelector('privacy-banner');
      if (!banner) return;
      enforceHidden(banner);
      new MutationObserver(function () {
        enforceHidden(banner);
      }).observe(banner, { attributes: true, attributeFilter: ['hidden', 'class', 'style'] });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyHidden);
    } else {
      applyHidden();
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target.closest(
        'privacy-banner [data-action="accept"], privacy-banner [data-action="decline"]'
      );
      if (!btn) return;
      try {
        localStorage.setItem(KEY, '1');
      } catch (e) {}
    },
    true
  );
})();
